export const GIFTCARDS_UPDATE = 'GIFTCARDS:UPDATE';
export const GIFTCARDTYPES_UPDATE = 'GIFTCARDS:UPDATE_TYPES';
